import { Stack, useMediaQuery, useTheme } from "@mui/material";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import badgeGoogle from "../assets/android.svg";
import icon from "../assets/app-icon.png";
import badgeApple from "../assets/ios.svg";
import phones from "../assets/phone-mockup.png";
import { APPSTORE_URL, CONSTANTS, PLAYSTORE_URL } from "../constants";

function Hero() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div id="hero">
      <Container maxWidth="lg" sx={{ padding: 2, paddingBottom: 0 }}>
        <Grid container>
          <Grid size={{ sm: 5 }}>
            {isSmallScreen ? (
              <Stack
                spacing={2}
                id="download-app"
              >
                <Typography variant="h1" textAlign="center">{CONSTANTS.primaryTagline}</Typography>
                <Typography textAlign="center">{CONSTANTS.secondaryTagline}</Typography>
                <Stack id="download-app" direction="column" gap={2} justifyContent="center" alignItems="center">
                  <img id="hero-app-icon" src={icon} />
                  <a href={APPSTORE_URL} target="_blank">
                    <img id="badge-apple" src={badgeApple} />
                  </a>
                  <a href={PLAYSTORE_URL} target="_blank">
                    <img id="badge-android" src={badgeGoogle} />
                  </a>
                </Stack>
              </Stack>
            ) : (
              <Stack
                justifyContent="center"
                sx={{ height: "100%" }}
                spacing={3}
                id="download-app"
              >
                <Typography variant="h1">{CONSTANTS.primaryTagline}</Typography>
                <Typography>{CONSTANTS.secondaryTagline}</Typography>
                <Stack direction="row" gap={2} alignItems="center">
                  <img id="hero-app-icon" src={icon} />
                  <a href={APPSTORE_URL} target="_blank">
                    <img id="badge-apple" src={badgeApple} />
                  </a>
                  <a href={PLAYSTORE_URL} target="_blank">
                    <img id="badge-android" src={badgeGoogle} />
                  </a>
                </Stack>
              </Stack>
            )}
          </Grid>
          <Grid size={{ sm: 7 }}>
            <div className="mask-phone">
              <img id="phone-mockup" src={phones} />
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default Hero;
